import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack } from "@chakra-ui/react";
import { Calendar, Info, ClipboardList, Bookmark } from "lucide-react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewFAQDrawer = ({ isOpen, onClose, faq }) => {
  if (!faq) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<Text fontSize="2xl" fontWeight="bold">FAQ Details</Text>}
      bodyContent={
        <Flex direction="column" p={8} width="100%">
          {/* FAQ Header */}
          <Flex justifyContent="space-between" alignItems="center">
            <Box>
              <Text fontSize="2xl" fontWeight="bold">
                {faq.question}
              </Text>
              <Text fontSize="sm" color="gray.500" mt={1}>
                Category: {faq.category}
              </Text>
            </Box>
          </Flex>

          <Flex mt={4} alignItems="center">
            <Icon as={Calendar} size={16} color="gray.500" mr={1} />
            <Text fontSize="sm" color="gray.500">
              Date Added: {new Date(faq.dateAdded).toLocaleDateString()}
            </Text>
          </Flex>

          <Divider my={6} />

          <Flex direction="column" p={4}>
            {/* FAQ Details */}
            <Box mb={6}>
              <Stack spacing={4}>
                <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={2}>
                  <Icon as={ClipboardList} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.500" fontSize="sm">
                    Question: {faq.question}
                  </Text>
                </Flex>
                <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={2}>
                  <Icon as={Bookmark} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.500" fontSize="sm">
                    Category: {faq.category}
                  </Text>
                </Flex>
                <Box border="1px" borderColor="gray.300" borderRadius="md" p={6} display="flex" alignItems="center">
                  <Icon as={Info} mr={3} color="gray.400" fontSize="lg" />
                  <Text fontWeight="500" color="gray.500" fontSize="md">
                    Answer: {faq.answer}
                  </Text>
                </Box>
              </Stack>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ViewFAQDrawer;
